import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import AnnouncementBar from "@/components/AnnouncementBar";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import FeatureStrip from "@/components/FeatureStrip";
import VehicleSection from "@/components/VehicleSection";
import StepsSection from "@/components/StepsSection";
import TrustSection from "@/components/TrustSection";
import FCASection from "@/components/FCASection";
import LenderSection from "@/components/LenderSection";
import FAQSection from "@/components/FAQSection";
import BottomSteps from "@/components/BottomSteps";
import Footer from "@/components/Footer";
import StickyBar from "@/components/StickyBar";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import StructuredData from "@/components/StructuredData";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import TermsOfEngagement from "@/pages/TermsOfEngagement";
import ComplaintsProcedure from "@/pages/ComplaintsProcedure";
import ClaimForm from "@/pages/ClaimForm";

function HomePage() {
  // Forward current page query-string params to any data-ratifi-forward link on click.
  // Runs on homepage only; cleaned up on unmount.
  useEffect(() => {
    if (!window.location.search) return;
    const qs = window.location.search;
    function handler(e) {
      var a = e.target.closest("a[data-ratifi-forward]");
      if (!a) return;
      try {
        var u = new URL(a.href, window.location.origin);
        new URLSearchParams(qs).forEach(function (v, k) {
          if (!u.searchParams.has(k)) u.searchParams.set(k, v);
        });
        a.href = u.toString();
      } catch (_) {}
    }
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(
      "section, .step-card, .proven-card, .fca-findings-card, .fca-timeline-card, .law-feature, .commitment-inner, .faq-item"
    );
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 }
    );
    elements.forEach((el) => {
      el.classList.add("fade-up");
      observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <div>
      <StructuredData />
      <Header />
      <Hero />
      <FeatureStrip />
      <VehicleSection />
      <StepsSection />
      <TrustSection />
      <FCASection />
      <LenderSection />
      <FAQSection />
      <BottomSteps />
      <Footer />
      <StickyBar />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <CookieBanner />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/terms-of-engagement" element={<TermsOfEngagement />} />
          <Route path="/complaints-procedure" element={<ComplaintsProcedure />} />
          <Route path="/claim" element={<ClaimForm />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
